<template>
  <div class="container-fluid">
    <div v-if="typeControlPermission">
      <div class="row">
        <div class="col"><Topbar ref="con1" @reload="reload" /></div>
      </div>
      <div class="row">
        <div class="col"><Bottombar ref="con2" /></div>
      </div>      
    </div>
    <span v-else v-text="'�z�S���޲z�v��'"></span>
  </div>        
</template>
<script>
import { mapState } from "vuex";
import Topbar from "./uscontrol/Verify_topbar.vue"
import Bottombar from "./uscontrol/Verify_bottomtbar.vue"


export default {
  name: 'Verify_actlist',   
  components: {
    Topbar,
    Bottombar,
  },
  data() {
    return {
      data: [],
    };
  },
  computed: {
    ...mapState("account", ["status", "user"]),
    ...mapState("makeorg", ["defaultval"]),
      typeControlPermission() {
        const currentVal = this.$route.name;
        // ���o acts_permissions �}�C�A�q defaultval.permissions.acts_permissions
        const acts_permissions = this.defaultval?.permissions?.acts_permissions || [];
        // ��� vals �� Advancementoption ���D�\��
        const adv = acts_permissions.find(item => item.vals === "Actmanagement");
        if (!adv) return null;
        // �b�� acts_detailpermission �̧� vals �� Type_control ���Ӷ�
        return adv.acts_detailpermission.find(d => d.vals === currentVal) || null;
      }     
  },
  mounted() {

  },
  methods: {
    reload(){
      this.$refs["con1"].reload()
      this.$refs["con2"].reload()
    }
  },
};
</script>